import { UserRetrieveResponse } from '@fireflyhealth/api'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import * as thunks from './patientsThunks'

interface PatientsState {
  byId: { [key: number]: UserRetrieveResponse }
}

const INITIAL_STATE: PatientsState = {
  byId: {},
}

const patientsSliceBase = createSlice({
  name: 'patients',
  initialState: INITIAL_STATE,
  reducers: {
    getPatientSuccess: (state, { payload: patient }: PayloadAction<UserRetrieveResponse>) => {
      state.byId[patient.id] = patient
    },
    getPatientError: state => {},
  },
})

export const patientsSlice = Object.assign(patientsSliceBase, { thunks })
